import React, { useEffect, useState } from 'react'
import styles from './scss/leftnav.module.scss';
import { leftnavassets, assets } from '../styles/assets/assets';
import { NavLink, useLocation } from 'react-router-dom';
import Tooltip from '../components/custom_components/toolTip';
import { ANALYTICS, CAMPAIGN_REPORTS, CONTACTS, CUSTOMER_VALUE, DASHBOARD, CAMPAIGN, SETTINGS } from '../constant';


const LeftNav = () => {
  const location = useLocation();
  const [activeState, setActiveState] = useState('dash');
  const handleNav = (menu: string) => {
    console.log("menu", menu);
    setActiveState(menu)
  }

  const isAiPilotActive =
    location.pathname === "/aipilot" ||
    location.pathname === "/aiPilotAnimation";

  useEffect(() => {
    let path = location.pathname
    if (DASHBOARD.includes(path)) {
      setActiveState("dash")
    } else if (CONTACTS.includes(path)) {
      setActiveState("contact")
    } else if (CUSTOMER_VALUE.includes(path)) {
      setActiveState("customer_value")
    } else if (CAMPAIGN_REPORTS.includes(path)) {
      setActiveState("campain")
    } else if (CAMPAIGN.includes(path)) {
      setActiveState("campaign")
    } else if (SETTINGS.includes(path)) {
      setActiveState("settings")
    } else if (ANALYTICS.includes(path)) {
      setActiveState("analytics")
    } else {
      setActiveState("dash")
    }
  }, [location.pathname])

  const activePaths = ["/aiPilot", "/aiPilotAnimation"];
  const handleNavigationClick=(event :any)=>{
    console.log("event",location.pathname , `/${event?.target?.baseURI?.split('/')?.pop()}`)

    if (location.pathname === `/campaigns`) {
      event.preventDefault();
    }
  }

  return (
    <div className={styles.leftnav}>
      <div className={styles.ltnverticallists}>
        <NavLink to={'/aiPilot'} className={`${styles.ltnnavlink}`} viewTransition style={{ pointerEvents: location.pathname === '/aiPilotAnimation' ? 'none' : 'auto' }}>
          {
            ({ isActive }) => (<div className={`${styles.ltnlistitem} ${activePaths.includes(location.pathname) ? styles.ltnactiveitem : ''}`}>
              <img src={activePaths.includes(location.pathname) ? leftnavassets.aipilot_active : leftnavassets.aipilot_inactive} alt="aipilot" /><span>AI Pilot</span>
            </div>)
          }
        </NavLink>

        <NavLink to={'/customer_profile'} className={styles.ltnnavlink} viewTransition>
          {
            ({ isActive }) => (
              <div className={`${styles.ltnlistitem} ${isActive ? styles.ltnactiveitem : ''}`}>
                <img src={isActive ? leftnavassets.customerprofile_active : leftnavassets.customerprofile_inactive} alt="customerprofile_inactive" /><span>Customer Profiles</span>
              </div>
            )
          }
        </NavLink>

        {/* <NavLink to={'/reports'} className={styles.ltnnavlink} viewTransition>
          {
            ({ isActive }) => (
              <div className={`${styles.ltnlistitem} ${isActive ? styles.ltnactiveitem : ''}`}>
                <img src={isActive ? leftnavassets.reports_active : leftnavassets.reports_inactive} alt="reports_inactive" /><span>Analytics</span>
              </div>
            )
          }
        </NavLink> */}

        <NavLink to={'/campaigns'} className={styles.ltnnavlink} viewTransition onClick={handleNavigationClick}>
          {
            ({ isActive }) => (
              <div className={`${styles.ltnlistitem} ${isActive ? styles.ltnactiveitem : ''}`}>
                <img src={isActive ? leftnavassets.campaign_active : leftnavassets.campaing_inactive} alt="campaigns" /><span>Campaigns</span>
              </div>
            )
          }
        </NavLink>

        <NavLink to={'/settings'} className={styles.ltnnavlink} viewTransition>
          {
            ({ isActive }) => (
              <div className={`${styles.ltnlistitem} ${isActive ? styles.ltnactiveitem : ''}`}>
                <img src={isActive ? leftnavassets.setting_active : leftnavassets.setting_inactive} alt="setting" /><span>Settings</span>
              </div>
            )
          }
        </NavLink>

      </div>
    </div>
  )
}

export default LeftNav
